import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { MobileSidebar } from './MobileSidebar'
import { GenerationNotification } from '../GenerationNotification'

export function Layout() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="h-screen overflow-hidden flex text-text-main">
      {/* Desktop Sidebar */}
      <Sidebar />

      {/* Main Content Area */}
      <main className="flex-1 overflow-y-auto h-full relative gradient-mesh-primary noise-overlay">
        {/* Mobile Header */}
        <Header onMenuClick={() => setMobileMenuOpen(true)} />

        {/* Mobile Sidebar */}
        <MobileSidebar
          isOpen={mobileMenuOpen}
          onClose={() => setMobileMenuOpen(false)}
        />

        {/* Content */}
        <div className="max-w-[1280px] mx-auto p-6 md:p-10 lg:p-12 flex flex-col gap-10 pb-20">
          <Outlet />
        </div>
      </main>

      {/* Generation Notification - Floating card */}
      <GenerationNotification />
    </div>
  )
}
